import { TypedUseSelectorHook, useSelector as selectorHook, useDispatch as dispatchHook, useStore as useReduxStore } from "react-redux";
import { RootState, TStore } from "../redux";
import { ThunkDispatch } from "redux-thunk";
import { Action } from "@reduxjs/toolkit";
import type { Store } from "redux";

export type TSelector<T> = (store: TStore) => T;

export const useSelector: TypedUseSelectorHook<TStore> = selectorHook;

export const useDispatch: () => ThunkDispatch<RootState, void, Action> = dispatchHook;

export function useStore(): Store<RootState> {
    return useReduxStore<RootState>();
}